/** Main site (/) — travel agency home page */
export const MAIN_PHONE_TEL = '+18774793948';
export const MAIN_PHONE_DISPLAY = '1-877-479-3948';

/** Flight pages (/flight) — search, booking, and policy pages */
export const FLIGHT_PHONE_TEL = '+18774793948';
export const FLIGHT_PHONE_DISPLAY = '1-877-479-3948';
